module.exports = __webpack_public_path__ + "static/media/10.8f79fd20.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/ad/2/10.png
// module id = 91
// module chunks = 0